/**
 * Ссылки на публичный сайт (репозиторий pomogatorus-nuxt3).
 *
 * Адрес определяется по тому, откуда открыта админка: локально (localhost / 127.0.0.1) — на
 * локальный сайт на :3000, иначе — на боевой. Явно задать можно через VUE_APP_FRONT_URL
 * (например, в .env.local), он важнее автоопределения.
 */
const LOCAL_FRONT_URL = "http://localhost:3000";
const PROD_FRONT_URL = "https://pomogatorus.ru";

const isLocalHost = () =>
  typeof window !== "undefined" && ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);

const frontBase = () =>
  (process.env.VUE_APP_FRONT_URL || (isLocalHost() ? LOCAL_FRONT_URL : PROD_FRONT_URL)).replace(/\/$/, "");

/** Страница публичного сайта по пути, например frontUrl("/articles/5"). */
export const frontUrl = (path = "") => `${frontBase()}${path}`;

/** Схема в конструкторе на фронте: pages/schemes/editor.vue открывает сохранённую схему по ?id=. */
export const frontSchemeUrl = (id) => frontUrl(`/schemes/editor?id=${id}`);
